import React from 'react';
import { NavLink } from 'react-router-dom';
import SwingSubmittalsPendingReviewCount from '../../swing-submittals/SwingSubmittalsPendingReviewCount';

function MainNavigation({ submittalsPendingReviewCount }) {
  return (
    <div className="main-navigation">
      <div className="main-navigation__title">
        Admin
        {process.env.REACT_APP_ENV === 'development' ? (
          <span className="env-string">DEV</span>
        ) : null}
        {process.env.REACT_APP_ENV === 'qa' ? (
          <span className="env-string">QA</span>
        ) : null}
        {process.env.REACT_APP_ENV === 'staging' ? (
          <span className="env-string">STAGING</span>
        ) : null}
      </div>
      <div className="main-navigation__links">
        <NavLink to="/courses" className="main-navigation__link" activeClassName="active">
          Courses
        </NavLink>
        <NavLink to="/tv/shows" className="main-navigation__link" activeClassName="active">
          Tathata TV
        </NavLink>
        <NavLink to="/movement-specialists" className="main-navigation__link" activeClassName="active">
          Movement Specialists
        </NavLink>
        <NavLink to="/users" className="main-navigation__link" activeClassName="active">
          User List
        </NavLink>
        <NavLink to="/badges" className="main-navigation__link" activeClassName="active">
          Badges
        </NavLink>
        <NavLink to="/library" className="main-navigation__link" activeClassName="active">
          Library
        </NavLink>
        <NavLink to="/golf-schools" className="main-navigation__link" activeClassName="active">
          Golf Schools
        </NavLink>
        <NavLink to="/swing-submittals" className="main-navigation__link nav-submittals" activeClassName="active">
          Swing Submittals <SwingSubmittalsPendingReviewCount count={submittalsPendingReviewCount} />
        </NavLink>
        <NavLink to="/follow-ups" className="main-navigation__link" activeClassName="active">
          Follow-Ups
        </NavLink>
        <NavLink to="/settings" className="main-navigation__link" activeClassName="active">
          Settings
        </NavLink>
        <NavLink to="/logout" className="main-navigation__link">
          Log Out
        </NavLink>
      </div>
    </div>
  );
}

export default MainNavigation;



// WEBPACK FOOTER //
// ./src/common/layout/MainNavigation.js